import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagVue from '@bugsnag/plugin-vue'

const BugsnagClient = Bugsnag(process.env.VUE_APP_BUGSNAG_API_KEY)
BugsnagClient.use(BugsnagVue, Vue)



// WEBPACK FOOTER //
// ./src/plugins/bugsnag.js